<template>
  <div>
    <a href="#/" class="btn btn-dark" @click="showUploadModal()">Upload Articles</a>

    <b-modal id="bv-modal-example" hide-footer hide-header>
      <template #modal-title>Upload Articles</template>

      <div class="row">
        <div class="col pt-4">
            <div class="mb-0 text-center">
            <div v-if="!filename">
                <form @submit="selectAttachment" enctype="multipart/form-data">
                  <label
                    for="account-upload"
                    class="btn btn-primary-outline m-0 px-0 py-0">
                    <i class="fas fa-paperclip fa-md mr-2"></i>Attach file</label>
                  <input
                    type="file"
                    id="account-upload"
                    accept=".zip"
                    hidden
                    class="form-control mt-2"
                    v-on:change="selectAttachment" />
                </form>
              </div>
              <div v-else>
                <small class="mr-2">{{ filename }}</small><span
                  @click="removeImage" class="badge badge-pill badge-danger badge-up remove">X</span>
              </div>
        </div>
      </div>
    </div>

      <div class="row">
        <div class="col">

      <label class="form-label pt-0 mb-0" for="dealer-name">Category</label>
      <i v-if="loading_categories" class="fas fa-spinner fa-spin fa-1x"></i>

    <v-select
        v-else
        :clearable="false"
        v-model.trim="category"
        class="select-box"
        :options="categories"
        label="name">
        <template #option="{ name }">
        <span>{{ name }}</span>
        </template>
    </v-select>

        </div>
      </div>

      <div class="row mt-2">
        <div class="col">
      <label class="form-label pt-0 mb-0" for="dealer-name">Status</label>
    <v-select
        :clearable="false"
        v-model.trim="status"
        class="select-box"
        :options="statuses"
        label="name">
        <template #option="{ name }">
        <span>{{ name }}</span>
        </template>
    </v-select>

        </div>
      </div>

      <div class="row pt-3 pb-2">
        <div class="col">
                  <div>
<button v-if="sending" type="button" class="btn btn-success submit col">
  <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i></button>
        <button v-else type="button" class="btn btn-dark submit col" @click="formSubmit">Upload</button>
      </div>
        </div>
      </div>

    </b-modal>
  </div>
</template> 

<script>
export default {
  props: ['project'],

  data() {
    return {
      file: null,
      filename: null,
      sending: false,
      category: null,
      status: { id: 1, name: 'Active'},
      statuses: [
        { id: 1, name: 'Active'},
        { id: 2, name: 'Inactive'},
      ],
      categories: [],
      loading_categories: false,
    };
  },

  created() {
    this.getCategories();
  },

  methods: {

     removeImage(e) {
      this.file = null;
      this.filename = null;
    },

    selectAttachment(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;
      this.file = files[0];
      this.filename = files[0]["name"];

      var document_response = this.document_check(this.file, "document");

      if (document_response.success !== true) {
        this.sweetfire(document_response.description);
        this.file = "";
        this.filename = "";
      }
    },

    showUploadModal() {
      this.$bvModal.show("bv-modal-example");
    },

    hideModal() {
      this.$bvModal.hide("bv-modal-example");
    },

    async formSubmit() {

      if (!this.file) {this.sweetfire('Please choose a file')}
        else if (!this.category) {this.sweetfire('Please choose a category')}
        else if (!this.status) {this.sweetfire('Please choose a status')}
        else {

        this.sending = true;

        let existingObj = this;

        const config = { headers: { "content-type": "multipart/form-data" } };

        let data = new FormData();
        data.append("file", this.file);
        data.append("category_id", this.category.id);
        data.append("status", this.status.name);

        await axios
          .post('/contacts/upload', data, config)
          .then(function (response) {

            if (response.data.success) {
                existingObj.hideModal();
                existingObj.sweetfire(response.data.message);
                existingObj.$emit('new-articles');
                existingObj.file = null;
                existingObj.filename = null;
                existingObj.category = null;
                existingObj.status = { id: 1, name: 'Active'};
            } else {
                existingObj.sweetfire(response.data.message);
            }
            
            existingObj.sending = false;

          })
          .catch(function (err) {
            console.log(err);
            existingObj.sending = false;
          });
      }
    },

      showToaster(text) {
      this.$toaster.success(text, { timeout: 2500 });
      },

      getCategories() {
      this.loading_categories = true;

      axios.get('/article-categories/get').then((response) => {
        this.categories = response.data;
        this.loading_categories = false;
      });
    },

      sweetfire(text) {
        Swal.fire({
        title: text,
        showConfirmButton: false,
        showDenyButton: false,
        showCancelButton: true,
        focusConfirm: false,
        cancelButtonText: 'Ok',
        customClass: {
                title: "popup-title",
                },
        })
    },

    sweetfire2(text) {
      Swal.fire({
      title: text,
      html: '<a href="/articles" target="_self" class="btn btn-danger">View</a>',
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: false,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: {
              title: "popup-title",
            },
      })
    },

  },
};
</script>

<style scoped>
select.form-select {
  background-color: #ffffff !important;
  border: 2px solid #35363a;
}
label.form-label {
  font-weight: 600 !important;
}
.remove {
  padding: 0.2rem 0.4rem;
  margin-bottom: 0.1rem;
}
.remove:hover {
  cursor: pointer;
}

</style>